<script>
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [];

if (!window.router) {
  window.router = new VueRouter({
    mode: 'history',
    routers: []
  });
}

export default window.router;

</script>